import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextInput, Button, Notification, rem, PasswordInput, Container, Title, Text } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import axios from 'axios';
import API_URL from '../../config';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(null);
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/api/users/reset-password-confirm/${uidb64}/${token}/`, {
        new_password: newPassword,
      });
      setMessage('Mot de passe réinitialisé avec succès. Redirection en cours...');
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      setMessage("Erreur lors de la réinitialisation du mot de passe.");
      setSuccess(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Title align="center" mb="lg">
        Définir un nouveau mot de passe
      </Title>
      <Text align="center" color="dimmed" size="sm" mb="xl">
        Veuillez entrer votre nouveau mot de passe pour continuer.
      </Text>
      <form onSubmit={handleSubmit}>
        <PasswordInput
          label="Nouveau mot de passe"
          placeholder="Entrez votre nouveau mot de passe"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          mb="md"
        />
        <Button type="submit" fullWidth variant="filled" color="blue" mt="md">
          Réinitialiser le mot de passe
        </Button>
      </form>
      {message && (
        <Notification
          icon={success ? <IconCheck size={rem(20)} /> : <IconX size={rem(20)} />}
          color={success ? 'teal' : 'red'}
          title={success ? 'Succès' : 'Erreur'}
          mt="lg"
          onClose={() => setMessage('')}
        >
          {message}
        </Notification>
      )}
    </Container>
  );
};

export default ResetPassword;